import {Link} from '@primer/react'
import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {CommentDeletedEvent$key} from './__generated__/CommentDeletedEvent.graphql'
import {TimelineRow} from './row/TimelineRow'
import {TrashIcon} from '@primer/octicons-react'

type CommentDeletedEventProps = {
  queryRef: CommentDeletedEvent$key
  issueUrl: string
  highlightedEventId?: string
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
}

export function CommentDeletedEvent({
  queryRef,
  issueUrl,
  highlightedEventId,
  refAttribute,
}: CommentDeletedEventProps): JSX.Element {
  const {actor, createdAt, deletedCommentAuthor, databaseId} = useFragment(
    graphql`
      fragment CommentDeletedEvent on CommentDeletedEvent {
        databaseId
        createdAt
        actor {
          ...EventActor
        }
        deletedCommentAuthor {
          login
        }
      }
    `,
    queryRef,
  )

  const highlighted = String(databaseId) === highlightedEventId
  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      leadingIcon={TrashIcon}
    >
      <TimelineRow.Main>
        {`${LABELS.timeline.deletedACommentFrom} `}
        <Link href={`/${deletedCommentAuthor?.login}`} sx={{color: 'fg.default'}} muted>
          {deletedCommentAuthor?.login}
        </Link>{' '}
      </TimelineRow.Main>
    </TimelineRow>
  )
}

try{ CommentDeletedEvent.displayName ||= 'CommentDeletedEvent' } catch {}